import { createFileRoute } from "@tanstack/react-router";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/_main/portfolio")({
	head: () =>
		generateSeo({
			title:
				"Our Portfolio | Bespoke Web Design & Next.js Projects in Bangalore",
			description:
				"Browse CraftLayer's portfolio of high-performance websites and applications. See how we deliver results through stunning design and flawless engineering for clients in Bangalore.",
			url: "/portfolio",
			keywords: [
				"CraftLayer portfolio",
				"web design case studies",
				"Next.js projects",
				"recent work",
				"project showcase",
				"bangalore web design portfolio",
			],
		}),
});
